class FloatingAddToCart {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.productId = container.dataset.productId;
    this.hasMultipleVariants = container.dataset.hasMultipleVariants === 'true';
    this.button = container.querySelector('.floating-atc__button');
    this.labelEl = container.querySelector('.floating-atc__label');

    if (!this.button || !this.labelEl) return;

    this.mainForm = document.querySelector(
      `#ProductInfo-${this.sectionId} form[data-type="add-to-cart-form"]`
    );

    if (!this.mainForm) return;

    // .gpo-containerの存在はinitVariantPicker()でチェック

    this.variantInput = this.mainForm.querySelector('.product-variant-id');
    this.errorWrapper = this.mainForm.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorWrapper
      ? this.errorWrapper.querySelector('.product-form__error-message')
      : null;

    this.defaultLabel = this.labelEl.textContent.trim();
    this.viewCartLabel = window.theme && window.theme.strings && window.theme.strings.viewCart
      ? window.theme.strings.viewCart
      : 'カートを見る';

    this.visibleClass = 'floating-atc--visible';
    this.resetTimer = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);

    this.initVariantPicker();

    this.initObserver();
    this.initSubscriptions();
    this.button.addEventListener('click', this.handleClick);
  }

  initObserver() {
    // 購入ボタンを複数の方法で検出
    const findSubmitButton = () => {
      const root = document.querySelector(`#ProductInfo-${this.sectionId}`) || document;
      
      // 方法1: IDで検索
      let button = root.querySelector(`#ProductSubmitButton-${this.sectionId}`);
      
      // 方法2: フォーム内のsubmitボタンを検索
      if (!button && this.mainForm) {
        button = this.mainForm.querySelector('button[type="submit"][name="add"]');
      }
      
      // 方法3: クラス名で検索
      if (!button) {
        button = root.querySelector('.product-form__submit');
      }
      
      // 方法4: フォーム全体をフォールバック
      return button || this.mainForm;
    };

    const target = findSubmitButton();
    
    if (!target) {
      // 購入ボタンが見つからない場合、初期状態で表示
      setTimeout(() => {
        this.show();
      }, 100);
      return;
    }

    // 初期状態をチェック（より正確に）
    const checkInitialState = () => {
      if (!target || !target.getBoundingClientRect) {
        this.show();
        return;
      }

      const rect = target.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // 購入ボタンが完全に画面外にあるかチェック
      // rect.bottom < 0: 購入ボタンが画面の上側に完全に隠れている
      // rect.top > windowHeight: 購入ボタンが画面の下側に完全に隠れている
      const isCompletelyOutOfView = rect.bottom < 0 || rect.top > windowHeight;
      
      if (isCompletelyOutOfView) {
        // 購入ボタンが完全に画面外にある場合は表示
        this.show();
      } else {
        // 購入ボタンが画面内に少しでも見えている場合は非表示
        this.hide();
      }
    };

    // 初期チェックを実行（少し遅延させて確実に）
    setTimeout(() => {
      checkInitialState();
    }, 200);

    // IntersectionObserverの設定
    const options = {
      root: null,
      threshold: [0, 0.1, 0.5, 1.0], // 複数の閾値で監視
      rootMargin: '0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const rect = entry.boundingClientRect;
        const windowHeight = window.innerHeight;
        
        // 購入ボタンが完全に画面外にあるかチェック
        const isCompletelyOutOfView = rect.bottom < 0 || rect.top > windowHeight;
        
        if (isCompletelyOutOfView) {
          // 購入ボタンが完全に画面外にある場合は表示
          this.show();
        } else {
          // 購入ボタンが画面内に少しでも見えている場合は非表示
          this.hide();
        }
      });
    }, options);

    // ターゲットを監視
    try {
      observer.observe(target);
    } catch (e) {
      console.warn('IntersectionObserver failed, using scroll fallback', e);
    }

    // スクロールイベントも監視（IntersectionObserverが動作しない場合のフォールバック）
    let scrollTimeout;
    let resizeTimeout;
    
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        checkInitialState();
      }, 50);
    };

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        checkInitialState();
      }, 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    
    // 定期的にもチェック（念のため）
    setInterval(() => {
      checkInitialState();
    }, 1000);
  }

  initVariantPicker() {
    const root = document.querySelector(`#ProductInfo-${this.sectionId}`) || document;

    // Shopify標準のバリエーションピッカー（より正確に検出）
    // .product-form__inputは数量選択なども含むため除外
    this.variantPicker =
      root.querySelector(`#variant-selects-${this.sectionId}`) ||
      root.querySelector('variant-selects') ||
      root.querySelector('variant-radios') ||
      null;

    // .gpo-containerを保存
    this.gpoContainer = root.querySelector('.gpo-container');
  }

  findAppOptions(root) {
    // 一般的なアプリの商品オプションのセレクタパターン
    // Globo Product Optionsを最優先
    const selectors = [
      '.gpo-container', // Globo Product Options
      '[data-app-option]',
      '[data-product-option]',
      '[data-custom-option]',
      '.app-option',
      '.product-option',
      '.custom-option',
      'shopify-app-block[data-block-type="product-option"]',
      '[name^="properties["]',
      '[data-shopify-app-block]',
      // より具体的なパターン
      '[id*="app-option"]',
      '[class*="app-option"]',
      '[class*="product-option"]',
    ];

    for (const selector of selectors) {
      const elements = root.querySelectorAll(selector);
      if (elements.length > 0) {
        return Array.from(elements);
      }
    }

    return [];
  }

  initSubscriptions() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
  }

  checkAppOptionsExist(root) {
    const selectors = [
      '.gpo-container', // Globo Product Options
      '[data-app-option]',
      '[data-product-option]',
      '[data-custom-option]',
      '.app-option',
      '.product-option',
      '.custom-option',
      'shopify-app-block[data-block-type="product-option"]',
      '[name^="properties["]',
      '[data-shopify-app-block]',
    ];

    return selectors.some((selector) => {
      const elements = root.querySelectorAll(selector);
      return elements.length > 0;
    });
  }

  getScrollTarget() {
    // バリエーションピッカーを最優先
    if (this.variantPicker) {
      return this.variantPicker;
    }

    // バリエーションピッカーがない場合、.gpo-containerがあればそれを返す
    if (this.gpoContainer) {
      return this.gpoContainer;
    }

    return null;
  }

  handleClick() {
    if (!this.mainForm) return;

    // 複数バリエーション商品または.gpo-containerがある場合は、オプション選択エリアへスクロール
    const scrollTarget = this.getScrollTarget();
    if ((this.hasMultipleVariants || this.gpoContainer) && scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // 軽いハイライト効果
      scrollTarget.classList.add('highlight-pulse');
      setTimeout(() => {
        scrollTarget.classList.remove('highlight-pulse');
      }, 500);

      // 最初の操作要素へフォーカス
      const focusTarget =
        scrollTarget.querySelector('input, button, select, [tabindex]:not([tabindex="-1"])') ||
        null;
      if (focusTarget) {
        setTimeout(() => {
          focusTarget.focus();
        }, 400);
      }

      return;
    }

    if (!this.variantInput || !this.variantInput.value || this.variantInput.disabled) {
      if (this.errorWrapper && this.errorMessage) {
        this.errorWrapper.hidden = false;
        this.errorMessage.textContent =
          (window.theme && window.theme.strings && window.theme.strings.variantRequired) ||
          'バリアントを選択してください。';
      }
      this.mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const submitButton = this.mainForm.querySelector('[type="submit"]');
    if (submitButton && submitButton.click) {
      submitButton.click();
    } else {
      this.mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }

  handleCartUpdate(event) {
    if (!event || !event.cartData || !event.cartData.items) return;

    const lastItem = event.cartData.items[event.cartData.items.length - 1];
    if (!lastItem || String(lastItem.product_id) !== String(this.productId)) return;

    this.setViewCartState();
  }

  setViewCartState() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
      this.resetTimer = null;
    }

    this.labelEl.textContent = this.viewCartLabel;

    this.button.onclick = () => {
      if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
      } else {
        window.location.href = '/cart';
      }
    };

    this.resetTimer = setTimeout(() => {
      this.labelEl.textContent = this.defaultLabel;
      this.button.onclick = null;
    }, 3000);
  }

  show() {
    this.container.classList.add(this.visibleClass);
    this.container.setAttribute('aria-hidden', 'false');
  }

  hide() {
    this.container.classList.remove(this.visibleClass);
    this.container.setAttribute('aria-hidden', 'true');
  }
}

function initFloatingButtons() {
  const containers = document.querySelectorAll('.floating-atc');
  containers.forEach((container) => {
    // 既に初期化されている場合はスキップ
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';
    new FloatingAddToCart(container);
  });
}

// DOMContentLoadedとloadイベントの両方で初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initFloatingButtons, 100);
  });
} else {
  setTimeout(initFloatingButtons, 100);
}

// ページ読み込み完了後にも初期化（動的要素対応）
window.addEventListener('load', () => {
  setTimeout(initFloatingButtons, 200);
});

// 動的に追加される要素に対応（MutationObserver）
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(() => {
    initFloatingButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}


